import React from 'react';
import styles from './HorizontalSeparator.module.css';

function HorizontalSeparator() {
  return <hr className={styles.hr} />;
}
export default HorizontalSeparator;
